export const TENANT_BOOTSTRAP_ERROR_CODES = Object.freeze({
  INVALID_TENANT_SLUG: "INVALID_TENANT_SLUG",
  TENANT_NOT_FOUND: "TENANT_NOT_FOUND",
  TENANT_INACTIVE: "TENANT_INACTIVE",
  TENANT_CONFIG_INVALID: "TENANT_CONFIG_INVALID",
  CENTRAL_FIRESTORE_UNAVAILABLE: "CENTRAL_FIRESTORE_UNAVAILABLE",
  CUSTOMER_FIREBASE_INIT_FAILED: "CUSTOMER_FIREBASE_INIT_FAILED",
  CENTRAL_FIREBASE_CONFIG_INVALID: "CENTRAL_FIREBASE_CONFIG_INVALID",
});

export class TenantBootstrapError extends Error {
  constructor(code, message, details = {}) {
    super(message);
    this.name = "TenantBootstrapError";
    this.code = code;
    this.details = details;
  }
}

